export default "__VITE_ASSET__DUF$nvqO__"